import MarkdownContent from "../MarkdownContent";
import {AccordionStyled} from "@/components/accordion/AccordionStyled";

export const NetworkFaq = ({ question, answer }) => {

  return (
      <AccordionStyled question={question}>
        <MarkdownContent input={answer} />
      </AccordionStyled>
  );
};
